const CAP43 = {
  id: 43,
  slug: "cap43-arquitectura-de-la-red-bitcoin",
  title: "Capítulo 43 — Arquitectura de la Red Bitcoin",
  module: 4,
  sections: [
    {
      heading: "Resumen del capítulo",
      text: [
        "En este capítulo se desarrolla el tema: Arquitectura de la Red Bitcoin."
      ]
    }
  ]
};

export default CAP43;
